import moment from 'moment';
import { dateTolocale } from './converter';

export const getAwbDetails = (data) => {
  let awb_no = data?.flight_awbs?.[0]?.awb_no;
  let pcs = 0;
  let wgt = 0;
  let org = '';
  let dest = '';
  let total_pcs = 0;
  let part = false;
  let parts = [];
  let remark = '';
  let spl_code = '';
  let flight_no = data?.flight?.airline?.code + data?.flight?.flight_no;
  let flight_arr = data?.flight?.act_arr ? dateTolocale(data?.flight?.act_arr, 'YYYY-MM-DD HH:mm') : (data?.flight?.est_arr ? dateTolocale(data?.flight?.est_arr, 'YYYY-MM-DD HH:mm') : dateTolocale(data?.flight?.schdl_arr, 'YYYY-MM-DD HH:mm'));
  let storage_start = moment(flight_arr).format('YYYY-MM-DD');
  let sstorage_start_date_time = flight_arr;
  let manual_storage_start = data?.storage_start ? data?.storage_start : null;
  if (data?.house_awb) {
    awb_no = data?.house_awb_no;
    pcs = data?.pcs;
    wgt = data?.wgt;
    org = data?.org;
    dest = data?.dest;
  } else {
    pcs = data?.flight_awbs?.reduce((acc, awb) => acc + parseInt(awb.pcs), 0);
    wgt = data?.flight_awbs?.reduce((acc, awb) => acc + parseFloat(awb.wgt), 0)?.toFixed(1);
    org = data?.flight_awbs?.[0]?.org;
    dest = data?.flight_awbs?.[0]?.dest;
    remark = data?.flight_awbs?.[0]?.remark;
    spl_code = data?.flight_awbs?.[0]?.spl_code;
    if (data?.awb) {
      total_pcs = data?.awb ? data?.awb?.pcs : 0;
      if (pcs < total_pcs && total_pcs > 0) {
        part = true;
        parts.push({
          pcs,
          flight: data?.flight
        });
      }
    }
    let all_pcs = pcs;
    if (data?.other_import_awbs && data?.other_import_awbs.length > 0) {
      data?.other_import_awbs.map((awb) => {
        let t_pcs = awb?.flight_awbs?.reduce((acc, a) => acc + parseInt(a.pcs), 0);
        let t_wgt = awb?.flight_awbs?.reduce((acc, a) => acc + parseFloat(a.wgt), 0);
        if (awb.next) {
          pcs += t_pcs;
          wgt = (parseFloat(wgt) + parseFloat(t_wgt))?.toFixed(1);
        }
        all_pcs += t_pcs;
        parts.push({
          pcs: t_pcs,
          flight: awb.flight
        });
      });
    }
    if (part) {
      let remaining = total_pcs - all_pcs;
      if (remaining > 0) {
        parts.push({
          pcs: remaining,
          flight: false
        });
      }
    }
  }
  return {
    awb_no,
    pcs,
    wgt,
    total_pcs,
    part,
    parts,
    org,
    dest,
    storage_start,
    sstorage_start_date_time,
    manual_storage_start,
    remark,
    spl_code,
    flight_no,
    flight_arr,
    pickup_date: data?.pickup_date || null
  };
};
